/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3StackAdaptCreativeAdMapping } from '../models/V3StackAdaptCreativeAdMapping';
import { V3StackAdaptCreativeTag } from '../models/V3StackAdaptCreativeTag';
import { HttpFile } from '../http/http';

/**
* Creative configuration for StackAdapt campaign
*/
export class V3StackAdaptCreative {
    /**
    * Creative ID
    */
    'creativeId'?: string;
    /**
    * Historical record of all campaign-ad associations for this creative. Each entry represents one time this creative was attached to a campaign and received an ad_id from StackAdapt. This array allows BI Export to access ref_ids even after creatives are detached from campaigns.
    */
    'adMappings'?: Array<V3StackAdaptCreativeAdMapping>;
    /**
    * List of tags associated with the creative
    */
    'tags'?: Array<V3StackAdaptCreativeTag>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "creativeId",
            "baseName": "creativeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "adMappings",
            "baseName": "ad_mappings",
            "type": "Array<V3StackAdaptCreativeAdMapping>",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "Array<V3StackAdaptCreativeTag>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptCreative.attributeTypeMap;
    }

    public constructor() {
    }
}

